export { default as Img200 } from './processed/200/OUTPOST_KEYART_LANDS.jpg';
export { default as Img400 } from './processed/400/OUTPOST_KEYART_LANDS.jpg';
export { default as Imgthumb } from './processed/thumb/OUTPOST_KEYART_LANDS.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/OUTPOST_KEYART_LANDS.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/OUTPOST_KEYART_LANDS.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      220,
      48,
      56
    ],
    "_population": 85,
    "_hsl": [
      0.9922480620155039,
      0.7107438016528926,
      0.5254901960784314
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      19,
      48,
      88
    ],
    "_population": 63,
    "_hsl": [
      0.5966183574879227,
      0.6448598130841121,
      0.20980392156862746
    ]
  },
  "Muted": {
    "_rgb": [
      77,
      118,
      176
    ],
    "_population": 43,
    "_hsl": [
      0.5976430976430976,
      0.391304347826087,
      0.49607843137254903
    ]
  },
  "LightMuted": {
    "_rgb": [
      186,
      186,
      213
    ],
    "_population": 22,
    "_hsl": [
      0.6666666666666666,
      0.24324324324324345,
      0.7823529411764706
    ]
  },
  "DarkMuted": {
    "_rgb": [
      83,
      47,
      65
    ],
    "_population": 206,
    "_hsl": [
      0.9166666666666666,
      0.27692307692307694,
      0.2549019607843137
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/OUTPOST_KEYART_LANDS.js